import React from 'react';
import { calculateVidrios } from '../utils/calculateElements';
import './Vidrios.css';

const Vidrios = ({ ventanaType, height, width, additionalMeasure }) => {
  if (!ventanaType || !height || !width) {
    return null;
  }

  console.log('Entrada Vidrios component:', { ventanaType, height, width });

  const numericHeight = parseInt(height);
  const numericWidth = parseInt(width);

  const vidrios = calculateVidrios(ventanaType, numericHeight, numericWidth, additionalMeasure);
  console.log('Resultado calculateVidrios:', vidrios);

  const renderVidrioItem = (medidas, label) => {
    console.log('Medidas en renderVidrioItem:', medidas, label);
    if (!medidas) {
      return null;
    }

    const alto = Math.round(medidas.vertical);
    const ancho = Math.round(medidas.horizontal);

    const formatearMedida = (medida) => {
      if (medida < 1000) {
        return `${medida} mm`;
      }
      const parteEntera = Math.floor(medida / 1000);
      const parteDecimal = medida % 1000;
      const decimalFormateado = parteDecimal.toString().padStart(3, '0');
      return `${parteEntera}.${decimalFormateado} mm`;
    };

    const altoFormateado = formatearMedida(alto);
    const anchoFormateado = formatearMedida(ancho);

    const isWiderThanTall = ancho > alto;
    const imageSrc = isWiderThanTall ? "/vidrios.png" : "/vidrios2.png";

    return (
      <div className="vidrio-item" key={`vidrio-${label}`}>
        <h5 style={{ fontSize: '0.875rem', marginBottom: '10px' }}>{label}</h5>
        <div className="vidrio-image-container">
          <img src={imageSrc} alt={`Vidrio ${label}`} className="vidrio-image" />
          <div className="vidrio-vertical">
            <span>{altoFormateado}</span>
          </div>
          <div className="vidrio-horizontal">
            <span>{anchoFormateado}</span>
          </div>
        </div>
      </div>
    );
  };

  const renderVidrioItems = (vidrios) => {
    if (!vidrios) return null;

    // Si es monoriel americano o proyectante fijo, renderizar ambos vidrios
    if (ventanaType.toLowerCase() === 'monorielamericano') {
      return (
        <>
          {renderVidrioItem(vidrios.fijo, 'Vidrio Fijo')}
          {renderVidrioItem(vidrios.movil, 'Vidrio Móvil')}
        </>
      );
    } else if (ventanaType.toLowerCase() === 'proyectantefijo') {
      return (
        <>
          {renderVidrioItem(vidrios.fijo, 'Vidrio Fijo')}
          {renderVidrioItem(vidrios.proyectante, 'Vidrio Proyectante')}
        </>
      );
    } else if (ventanaType.toLowerCase() === 'doblerielamericano') {
      return (
        <>
          {renderVidrioItem(vidrios.movil1, 'Vidrio Móvil 1')}
          {renderVidrioItem(vidrios.movil2, 'Vidrio Móvil 2')}
        </>
      );
    }

    // Para otros tipos de ventanas, renderizar un solo vidrio
    return renderVidrioItem(vidrios, 'Vidrio');
  };

  if (!vidrios) {
    console.log('No hay vidrios para mostrar');
    return null;
  }

  return (
    <div className="vidrios-wrapper">
      <div className="vidrios">
        <h4 style={{ fontSize: '1rem', fontWeight: 'bold' }}>Medidas de Vidrios</h4>
        <div className="vidrios-content">
          {renderVidrioItems(vidrios)}
        </div>
      </div>
    </div>
  );
};

export default Vidrios;
